/**
 * Decrypts a base64-encoded AES-256-GCM payload produced by the backend.
 * Expected wire format: base64( IV[12] || ciphertext+authTag[n+16] )
 */
export async function decryptBody(data: string, aesKey: CryptoKey): Promise<unknown> {
  const combined = Uint8Array.from(atob(data), (c) => c.charCodeAt(0));
  const iv = combined.slice(0, 12);
  const ciphertextAndTag = combined.slice(12);

  const plaintext = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    aesKey,
    ciphertextAndTag
  );

  return JSON.parse(new TextDecoder().decode(plaintext));
}
